import React, { useState } from "react";
import {
  DialogContent,
  Card,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  CardContent,
} from "@material-ui/core";
import Colors from "shared/color";
import CustomInput from "components/custom/CustomInput";
import { toastSuccess, toastWarning } from "shared/utils";
import { changePaymentReason } from "shared/api";
import MNativeSelect from "components/ui/MNativeSelect";

const TCell = (props) => {
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...props.style,
      }}
    >
      {props.children}
    </TableCell>
  );
};

const defaultOptions = {
  LOAN_PAYMENT: "FORCLOSURE_FEES",
  FORCLOSURE_FEES: "LOAN_PAYMENT",
  MORATORIUM: "LOAN_PAYMENT",
  SNOOZE: "LOAN_PAYMENT",
  FLIPKART_PAYMENT: "LOAN_PAYMENT",
};
const Options = {
  LOAN_PAYMENT: {
    FORCLOSURE_FEES: "FORCLOSURE_FEES",
    FLIPKART_PAYMENT: "FLIPKART_PAYMENT",
  },
  FORCLOSURE_FEES: { LOAN_PAYMENT: "LOAN_PAYMENT" },
  MORATORIUM: { LOAN_PAYMENT: "LOAN_PAYMENT" },
  SNOOZE: { LOAN_PAYMENT: "LOAN_PAYMENT" },
  FLIPKART_PAYMENT: { LOAN_PAYMENT: "LOAN_PAYMENT" },
};

export const ChangeReason = ({ handleClose, data }) => {
  const [loanRefNo, setLoanRefNo] = useState("");
  const [changeReason, setChangeReason] = useState(
    defaultOptions[data["payment_request_reason"]]
  );
  
  const changeReasonHandler = (e) => {
    e.preventDefault();
    if (!changeReason || !changeReason === "") return false;
    let reqData = {};
    reqData["payment_request_reason"] = changeReason;
    if (changeReason === "FORCLOSURE_FEES") {
      reqData["loan_reference_number"] = loanRefNo;
    }

    changePaymentReason(data["payment_reference_number"], reqData)
      .then((res) => {
        if (res.success) {
          toastSuccess(res.message);
        } else {
          toastWarning(res.message);
        }
        handleClose(false);
      })
      .catch((error) => {});
  };

  return (
    <>
      <DialogContent
        dividers={false}
        style={{
          backgroundColor: Colors["lighterPurple"],
          fontSize: "0.8125rem",
          // minWidth: "40vw",
        }}
      >
        <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
          <Card>
            <CardContent>
              <TableContainer>
                <Table size="small" aria-label="simple table">
                  <TableBody>
                    <TCell>Reason </TCell>
                    <TCell>
                      <MNativeSelect
                        onChange={(e) => {
                          setChangeReason(e.target.value);
                        }}
                        style={{ width: "100%" }}
                        value={changeReason}
                        options={Options[data["payment_request_reason"]]}
                        // options={{1:"2",3:"4"}}
                      />
                    </TCell>
                  </TableBody>
                  {changeReason === "FORCLOSURE_FEES" ? (
                    <TableBody>
                      <TCell>Loan Reference Number</TCell>
                      <TCell>
                        <CustomInput
                          style={{
                            width: "100%",
                          }}
                          textFiledStyle={{ width: "100%" }}
                          value={loanRefNo}
                          onChange={(e) => setLoanRefNo(e.target.value)}
                          placeholder="Loan Reference Number"
                        />
                      </TCell>
                    </TableBody>
                  ) : null}
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={changeReasonHandler}
          color="primary"
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
          //   disabled={isSubmitting || !isValid}
        >
          Submit
        </Button>
        <Button
          onClick={handleClose}
          variant="contained"
          className="shadow-none"
          type="submit common_kissht_btn"
          //   disabled={isSubmitting || !isValid}
        >
          Close
        </Button>
      </DialogActions>
    </>
  );
};
